import React from 'react'
import MemberPage from '../../modules/admintbk/MemberPage'

const DataKasir = () => {
    return (
        <MemberPage></MemberPage>
    )
}

export default DataKasir